import * as ViewModel from "../../../models/ViewModel";
import { ViewHelper } from "../ViewHelper";
import { BonusInfo } from "../../../models/BonusInfo";
import { UserInfoCurrent } from "sb-resp-lib";

export class CalculatedPeriodHelper {

    constructor() {
        this.viewHelperDependency = ViewHelper.getInstance();
    }

    private static instance: CalculatedPeriodHelper;

    static getInstance(): CalculatedPeriodHelper {
        if (!this.instance) {
            this.instance = new CalculatedPeriodHelper();
        }

        return this.instance;
    }

    private viewHelperDependency: ViewHelper;
    private currentUserInfo?: UserInfoCurrent;

    setCurrentUserInfo(currentUserInfo?: UserInfoCurrent) {
        this.currentUserInfo = currentUserInfo;
    }

    setViewHelperDependency(viewHelper: ViewHelper) {
        this.viewHelperDependency = viewHelper;
    }

    wrappedCalculatedPeriodsStateless(stake: number, pulseBetMetadata: ViewModel.PulseBetMarketAdditionalData, bonusInfo?: BonusInfo): ViewModel.CalculatedPeriod[] {

        let numberOfPeriods = pulseBetMetadata.periods.length;
        let percentOfEachPeriod = 100 / numberOfPeriods;

        const result: ViewModel.CalculatedPeriod[] = [];

        for (let index = 0; index < pulseBetMetadata.periods.length; index++) {
            let calculatedPeriod = this.transformPeriodToCalculatedPeriodStateless(pulseBetMetadata.periods[index], index, stake, pulseBetMetadata, percentOfEachPeriod, bonusInfo);
            calculatedPeriod.absolutePercentFromTotal = calculatedPeriod.relativePercentFromTotal + (index > 0 ? result[index - 1].absolutePercentFromTotal : 0);
            result.push(calculatedPeriod);
        };

        return result;
    }

    formatWinnings(winnings: number): string {
        let formattedWinnings = `${winnings}`;
        if (this.currentUserInfo) {
            formattedWinnings = this.currentUserInfo.toUserFormatedCurrencyString(winnings);
        }

        formattedWinnings = formattedWinnings.replace(/\s+/g, ""); //remove all space

        let winningValue = formattedWinnings.match(/[0-9-.]+/ig);
        if ((formattedWinnings.match(/\./g) || formattedWinnings.match(/\,/g)) && winningValue && winningValue[0])
        {
            let p = winningValue[0].replace(/0*$|\.0+$/g, "");              //remove all trailing zeros
            formattedWinnings = formattedWinnings.replace(/[0-9-.]+/ig, p);
        }

        return formattedWinnings;
    }

    private transformPeriodToCalculatedPeriodStateless(p: ViewModel.PulseBetPeriod, index: number, stake: number, pulseBetMetadata: ViewModel.PulseBetMarketAdditionalData, percentOfEachPeriod: number, bonusInfo?: BonusInfo): ViewModel.CalculatedPeriod {

        let calculatedWin = Math.floor(+(stake * p.europeanOdds * 100).toPrecision(12)) / 100;
        calculatedWin = bonusInfo && !bonusInfo.isRiskFreeBet ? calculatedWin - bonusInfo.amount : calculatedWin;
        let calculated = new ViewModel.CalculatedPeriod({
            index,
            isLast: index + 1 === pulseBetMetadata.periods.length,
            period: p,
            calculatedWin,
            formatedWin: this.formatWinnings(calculatedWin),
            periodDurationInMilli: p.endTimeInMilli - p.startTimeInMilli,
            relativePercentFromTotal: percentOfEachPeriod,
            absolutePercentFromTotal: percentOfEachPeriod * (index + 1),
            invertedStartTimeInMinutesFormat: this.viewHelperDependency.milliToMinutesString(pulseBetMetadata.durationInMilli - p.startTimeInMilli),
            relativeRangeFormatted: this.viewHelperDependency.milliRangeToMinutesRange(p.startTimeInMilli, p.endTimeInMilli, pulseBetMetadata.typeId),
            absoluteToGameFormattedGameStart: "",
            absoluteGameFormattedGameEnd: "",
            absoluteToGameStartInMilli: 0,
            absoluteToGameEndInMilli: 0,
        });

        return calculated;

    }

    wrappedCalculatedPeriods(stake: number, pulseBetMetadata: ViewModel.PulseBetMarketAdditionalData): ViewModel.CalculatedPeriod[] {
        var result = this.wrappedCalculatedPeriodsStateless(stake, pulseBetMetadata);

        for (let period of result) {
            period.absoluteToGameStartInMilli = period.period.startTimeInMilli;
            period.absoluteToGameEndInMilli = period.period.endTimeInMilli;
            period.absoluteToGameFormattedGameStart = this.viewHelperDependency.milliToMinutesString(period.absoluteToGameStartInMilli);
            period.absoluteGameFormattedGameEnd = this.viewHelperDependency.milliToMinutesString(period.absoluteToGameEndInMilli);
        };

        return result;
    }
}